import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Data } from '@angular/router';

import { Usuario } from '../models/usuario';
import { Papel } from '../models/papel';
import { Permissao } from '../models/permissao';
import { GerenciarPerfisUsuariosResolverData } from '../models/gerenciar-perfis-usuarios-resolver-data';

@Component({
  selector: 'app-gerenciar-perfis-usuarios',
  templateUrl: './gerenciar-perfis-usuarios.component.html',
  styleUrl: './gerenciar-perfis-usuarios.component.scss',
  standalone: false,
})
export class GerenciarPerfisUsuariosComponent implements OnInit {

  usuarios: Usuario[] = [];
  papeis: Papel[] = [];
  permissoes: Permissao[] = [];

  constructor(
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.route.data.subscribe((data: Data) => {
      const resolverData = data['gerenciarPerfisUsuarios'] as GerenciarPerfisUsuariosResolverData;
      this.usuarios = resolverData.usuarios;
      this.papeis = resolverData.papeis;
      this.permissoes = resolverData.permissoes;
    });
  }
}
